import { render, staticRenderFns } from "./PlatformDisclaimer.vue?vue&type=template&id=d91a06ac&scoped=true"
import script from "./PlatformDisclaimer.vue?vue&type=script&lang=js"
export * from "./PlatformDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./PlatformDisclaimer.vue?vue&type=style&index=0&id=d91a06ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91a06ac",
  null
  
)

export default component.exports